import makeRequest from './helpers/makeRequest.js'
import promiseTabletop from './helpers/promiseTabletop.js'

import initializer from './mapSetup/initMap'
import appendScript from './mapSetup/appendScript'

import { uris } from './config/config'

require('./styles/styles.css')
const Tabletop = require('tabletop')

window.Tabletop = Tabletop

const TOPO_JSON_URL = uris.topoJson
const DATA_KEY = uris.newAnonData

const topoJsonPromise = makeRequest(TOPO_JSON_URL).then(res =>
  JSON.parse(res)
)
const dataPromise = promiseTabletop(DATA_KEY)

// Promise.all resolves when all provided promises
// have resolved (a.k.a. files have loaded)
Promise.all([topoJsonPromise, dataPromise])
  .then((files) => {
    return initializer(files)
  })
  .then(() => appendScript())
  .catch(error => console.log(error))



// WEBPACK FOOTER //
// ./src/index.js